import {
  ToolbarPopoverActionButton,
  ToolbarPopoverButton,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.popover";
import { View } from "@-/com.npmjs.react-native";
import { copyMorphemeToClipboard } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.card-actions";

export function MoreIconButton({
  character,
  onGiveFeedback,
}: {
  character: string;
  /**
   * Presents the mnemonic feedback sheet. The caller owns the sheet: this button can sit inside a
   * More menu, whose content unmounts the moment the menu closes, which is when the action runs.
   */
  onGiveFeedback: () => void;
}) {
  return (
    <View className="shrink-0 flex-row items-center">
      <ToolbarPopoverButton
        accessibilityLabel="Morpheme actions"
        iconSize={17}
        label="More"
        name="FiMoreHorizontal"
      >
        <ToolbarPopoverActionButton
          label={`Copy ${character}`}
          name="MdContentCopy"
          onPress={() => copyMorphemeToClipboard(character)}
          testID="copy-morpheme-menu-item"
        />
        <ToolbarPopoverActionButton
          label="Give Feedback"
          name="LuMessageSquare"
          onPress={onGiveFeedback}
          testID="give-feedback-menu-item"
        />
      </ToolbarPopoverButton>
    </View>
  );
}
